import React, { FC, PropsWithChildren } from 'react';
import cls from 'classnames';
import styles from './index.module.scss';

interface Props {
    clsName?: string;
    bgColor?: string;
}

export const Block: FC<PropsWithChildren<Props>> = ({
    children,
    clsName,
    bgColor,
}) => {
    return (
        <div
            className={styles.blockWrapper}
            style={{ backgroundColor: bgColor || 'transparent' }}
        >
            <div className={cls(styles.block, clsName)}>{children}</div>
        </div>
    );
};
